<template>
  <div>
    <b-modal id="modal-input" v-model="showModal" size="xl" :title="$store.state.kpi.modalTitle" hide-footer scrollable>
      <b-container>
        <b-card>
          <!-- Stepper Progress -->
          <b-progress :max="steps.length" height="20px" class="mb-3">
            <b-progress-bar :value="currentStep + 1" variant="info">Step {{ currentStep + 1 }} / {{ steps.length }}</b-progress-bar>
          </b-progress>

          <!-- Dynamic Step Title -->
          <h4 class="mb-4 text-center">{{ steps[currentStep].title }}</h4>
          <!-- Step Forms -->
          <div v-if="currentStep === 0">
            <b-form>
              <b-form-group :label="$store.state.kpi.email" label-cols-md="4">
                <b-form-input type="text" v-model="data.email"></b-form-input>
              </b-form-group>

              <b-form-group :label="$store.state.kpi.namaPenilai" label-cols-md="4">
                <b-form-input type="text" v-model="data.namaPenilai"></b-form-input>
              </b-form-group>

              <b-form-group :label="$store.state.kpi.jabatanPenilai" label-cols-md="4">
                <b-form-input type="text" v-model="data.jabatanPenilai"></b-form-input>
              </b-form-group>

              <b-form-group :label="$store.state.kpi.tempatTugas" label-cols-md="4">
                <b-form-input type="text" v-model="data.tempatTugas"></b-form-input>
              </b-form-group>

              <b-form-group :label="$store.state.kpi.tanggalPenilaian" label-cols-md="4">
                <DatePicker style="width: 100%" v-model="data.tanggalPenilaian" />
              </b-form-group>

              <b-form-group :label="$store.state.kpi.namaKaryawan" label-cols-md="4">
                <b-form-select :options="karyawan" type="text" v-model="data.selectedKaryawan" @change="assign($event)"></b-form-select>
              </b-form-group>

              <b-form-group :label="$store.state.kpi.tugasKerjaKaryawan" label-cols-md="4">
                <b-form-radio-group v-model="data.namaPosisi" :options="optionsRoles" stacked class="pl-2" />
              </b-form-group>
            </b-form>
          </div>

          <!-- Aspek Kepribadian -->
          <div v-else-if="currentStep === 1">
            <b-card-body>
              <b-form-group v-for="i in [1, 2, 3, 4, 5]" :key="i" :label="$store.state.kpi['penilaian' + i]" label-cols-md="4">
                <b-form-radio-group v-model="data['penilaian' + i]" :options="getOptions(i)" stacked class="pl-2" />
              </b-form-group>
            </b-card-body>
          </div>

          <!-- Aspek Komunikasi -->
          <div v-else-if="currentStep === 2">
            <b-card-body>
              <b-form-group v-for="i in [6, 7, 8, 9, 10]" :key="i" :label="$store.state.kpi['penilaian' + i]" label-cols-md="4">
                <b-form-radio-group v-model="data['penilaian' + i]" :options="getOptions(i)" stacked class="pl-2" />
              </b-form-group>
            </b-card-body>
          </div>

          <!-- Teknis Pekerjaan -->
          <div v-else-if="currentStep === 3">
            <b-card-body>
              <b-form-group v-for="i in [11, 12, 13, 14, 15]" :key="i" :label="$store.state.kpi['penilaian' + i]" label-cols-md="4">
                <b-form-radio-group v-model="data['penilaian' + i]" :options="getOptions(i)" stacked class="pl-2" />
              </b-form-group>
            </b-card-body>
          </div>

          <!-- Produktivitas -->
          <div v-else-if="currentStep === 4">
            <b-card-body>
              <b-form-group v-for="i in [16, 17, 18, 19, 20]" :key="i" :label="$store.state.kpi['penilaian' + i]" label-cols-md="4">
                <b-form-radio-group v-model="data['penilaian' + i]" :options="getOptions(i)" stacked class="pl-2" />
              </b-form-group>
            </b-card-body>
          </div>

          <!-- Catatan -->
          <div v-else-if="currentStep === 5">
            <b-card-body>
              <b-form-group :label="$store.state.kpi.catatanKhusus" label-cols-md="4">
                <b-form-input type="text" v-model="data.catatanKhusus" />
              </b-form-group>

              <b-form-group :label="$store.state.kpi.persetujuanPenandatanganan" label-cols-md="4">
                <b-form-radio-group v-model="data.persetujuanPenandatanganan" :options="optionsSetuju" stacked class="pl-2" />
              </b-form-group>

              <b-form-group :label="$store.state.kpi.jangkaWaktuKerjaLabel" label-cols-md="4">
                <b-form-input type="number" v-model="data.jangkaWaktuKerja" />
              </b-form-group>
            </b-card-body>
          </div>

          <!-- Step Navigation -->
          <b-row class="mt-4">
            <b-col cols="6">
              <b-button block variant="secondary" :disabled="currentStep === 0" @click="prevStep"> Back </b-button>
            </b-col>
            <b-col cols="6">
              <b-button block variant="primary" v-if="currentStep < steps.length - 1" @click="nextStep"> Next </b-button>

              <b-button block variant="success" v-else @click="register" :disabled="!isValid">
                {{ $store.state.kpi.kirimPenilaian }}
              </b-button>
            </b-col>
          </b-row>
        </b-card>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [validationMixin],
  props: ["posisi", "karyawan"],
  data() {
    return {
      showModal: false,
      currentStep: 0,
      steps: [{ title: "Identitas Penilai" }, { title: "Aspek Kepribadian" }, { title: "Aspek Komunikasi" }, { title: "Teknis Pekerjaan" }, { title: "Aspek Produktivitas" }, { title: "Catatan" }],
      data: {
        email: null,
        namaPenilai: null,
        jabatanPenilai: null,
        tempatTugas: null,
        tanggalPenilaian: null,
        catatanKhusus: null,
        persetujuanPenandatanganan: null,
        jangkaWaktuKerja: null,
        poin: null,
        suratPerjanjianKerjaId: null,
        dataKaryawanId: null,
        namaKaryawan: null,
        namaPosisi: null,
        // karyawan:[],
        totalPoin: 0,
        penilaian1: 0,
        penilaian2: 0,
        penilaian3: 0,
        penilaian4: 0,
        penilaian5: 0,
        penilaian6: 0,
        penilaian7: 0,
        penilaian8: 0,
        penilaian9: 0,
        penilaian10: 0,
        penilaian11: 0,
        penilaian12: 0,
        penilaian13: 0,
        penilaian14: 0,
        penilaian15: 0,
        penilaian16: 0,
        penilaian17: 0,
        penilaian18: 0,
        penilaian19: 0,
        penilaian20: 0,
      },
    };
  },
  validations: {
    data: {
      email: { required },
      namaPenilai: { required },
      jabatanPenilai: { required },
      tempatTugas: { required },
      tanggalPenilaian: { required },
      catatanKhusus: { required },
      persetujuanPenandatanganan: { required },
      jangkaWaktuKerja: { required },
      namaKaryawan: { required },
      namaPosisi: { required },
    },
  },
  computed: {
    isValid() {
      return !this.$v.data.$invalid;
    },

    totalss() {
      let x = 0;
      for (let i = 1; i <= 20; i++) {
        x += this.data["penilaian" + i];
      }
      return x;
    },

    optionsRoles() {
      return this.posisi || [];
    },

    optionsSetuju() {
      const s = this.$store.state.kpi || {};
      return [
        { text: s.optionsSetuju?.[0] || "Agree", value: true },
        { text: s.optionsSetuju?.[1] || "Disagree", value: false },
      ];
    },

    // Personality Aspect
  },
  methods: {
    assign(x) {
      const vm = this;
      const selectedPosisi = vm.posisi.find((pos) => pos.masterPosisiId === x.masterPosisiId);
      vm.data.namaKaryawan = x.namaKaryawan;
      vm.data.dataKaryawanId = x.dataKaryawanId;
      vm.data.suratPerjanjianKerjaId = x.suratPerjanjianKerjaId;
      vm.data.namaPosisi = selectedPosisi ? selectedPosisi.namaPosisi : null;
    },
    getOptions(i) {
      const s = this.$store.state.kpi || {};
      const arr = s["options" + i] || [];

      // Different value mapping per index if needed
      const valuesMap = {
        1: [3, 2, 1],
        2: [3, 2, 1],
        3: [3, 2, 1],
        4: [3, 2, 1],
        5: [3, 2, 1],
        6: [3, 2, 1],
        7: [3, 2, 1],
        8: [3, 2, 1],
        9: [3, 2, 1],
        10: [3, 2, 1],
        11: [3, 2, 1],
        12: [3, 2, 1],
        13: [3, 2, 1],
        14: [3, 2, 1],
        15: [3, 2, 1],
        16: [3, 2, 1],
        17: [3, 2, 1],
        18: [3, 2, 1],
        19: [3, 2, 1],
        20: [3, 2, 1],
      };

      const values = valuesMap[i] || [3, 2, 1];

      return arr.map((text, idx) => ({
        text,
        value: values[idx] ?? null,
      }));
    },
    nextStep() {
      if (this.currentStep < this.steps.length - 1) this.currentStep++;
    },
    prevStep() {
      if (this.currentStep > 0) this.currentStep--;
    },
    register() {
      this.data.totalPoin = this.totalss;
      this.$axios
        .post("penilaianKinerja/register", this.data)
        .then((res) => {
          if (res.data.status == 200) {
            this.$store.commit("set_alert", {
              variant: "success",
              msg: this.$store.state.kpi.successMsg,
              showing: true,
            });
          }
          this.$bvModal.hide("modal-input");
        })
        .catch((err) => {
          this.$store.commit("set_alert", {
            variant: "danger",
            msg: err.message.toUpperCase(),
            showing: true,
          });
        });
    },
  },
};
</script>

<style scoped>
/* Make the stepper clean */
.b-progress {
  border-radius: 20px;
  overflow: hidden;
}
</style>
